
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d1p2I", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $5dK2X = parcelRequire("5dK2X");


var $gCJ98 = parcelRequire("gCJ98");

const $d562a938958ff7a0$var$styles = {
    textWrapper: "_195g1wug _p12fo8uj _1e0c1o8l",
    imageWrapper: "_n3td1jfw"
};
function $d562a938958ff7a0$export$618cc98292cae482({ testId: testId = 'navigation-empty-state', renderImage: renderImage = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d562a938958ff7a0$var$styles.imageWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gCJ98.GenericErrorIcon), {})
    }), description: description, ...restProps }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
        ...restProps,
        testId: testId,
        renderImage: renderImage,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                $d562a938958ff7a0$var$styles.textWrapper
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtle",
                children: description
            })
        })
    });
}
module.exports["NavEmptyState"] = $d562a938958ff7a0$export$618cc98292cae482;

});

parcelRegister("gCJ98", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $40RQI = parcelRequire("40RQI");

const $1fbb045fdeaef17c$export$f370712d0ce7173b = ()=>{
    const theme = (0, $40RQI.useColorMode)();
    const isDarkTheme = theme === 'dark';
    const fillColour = isDarkTheme ? '#4B4D51' : '#DDDEE1';
    const innerColour = isDarkTheme ? '#101214' : 'white';
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        "data-testid": "navigation-empty-state--generic-error-icon",
        width: "57",
        height: "53",
        viewBox: "0 0 57 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
                fill: fillColour
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
                fill: innerColour
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
                fill: innerColour
            })
        ]
    });
};
module.exports["GenericErrorIcon"] = $1fbb045fdeaef17c$export$f370712d0ce7173b;

});

parcelRegister("dBtY8", function(module, exports) {
/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */ const $62b96c634929dcc9$export$98b0f7a0d3bb5010 = 'customization-modal';
const $62b96c634929dcc9$export$980ebe5373108eff = 'drag-and-drop';
const $62b96c634929dcc9$export$f7d1e5ad9f9f300d = 'global-more-menu';
const $62b96c634929dcc9$export$690e8743ad603dd3 = 'global-more-menu-item';
const $62b96c634929dcc9$export$1cb3fe63ec81f460 = 'global-shortcuts';
const $62b96c634929dcc9$export$29208be8b6408bd4 = 'global-side-navigation';
const $62b96c634929dcc9$export$649c709379c80e01 = 'global-side-navigation-item';
const $62b96c634929dcc9$export$46aed26dfad8c2b0 = 'gsn-main-nav-item';
const $62b96c634929dcc9$export$7b1d5fb8b81e96a9 = 'ribbon';
module.exports["ERROR_LOCATION__CUSTOMIZATION_MODAL"] = $62b96c634929dcc9$export$98b0f7a0d3bb5010;
module.exports["ERROR_LOCATION__DRAG_AND_DROP"] = $62b96c634929dcc9$export$980ebe5373108eff;
module.exports["ERROR_LOCATION__GLOBAL_MORE_MENU"] = $62b96c634929dcc9$export$f7d1e5ad9f9f300d;
module.exports["ERROR_LOCATION__GLOBAL_MORE_MENU_ITEM"] = $62b96c634929dcc9$export$690e8743ad603dd3;
module.exports["ERROR_LOCATION__GLOBAL_SHORTCUTS"] = $62b96c634929dcc9$export$1cb3fe63ec81f460;
module.exports["ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION"] = $62b96c634929dcc9$export$29208be8b6408bd4;
module.exports["ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS"] = $62b96c634929dcc9$export$649c709379c80e01;
module.exports["ERROR_LOCATION__GSN_MAIN_NAV_ITEM"] = $62b96c634929dcc9$export$46aed26dfad8c2b0;

});

parcelRegister("5xxOu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $1cfRh = parcelRequire("1cfRh");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $eduVw = parcelRequire("eduVw");


var $4rFRN = parcelRequire("4rFRN");


var $kTXVr = parcelRequire("kTXVr");


var $a9ATV = parcelRequire("a9ATV");


var $5IDSL = parcelRequire("5IDSL");


var $6yeRn = parcelRequire("6yeRn");


var $7u5NE = parcelRequire("7u5NE");

function $4c2fb4ef44ce22b7$export$afc779e659fd533f(props) {
    const { UNSAFE_wrapper: UNSAFE_wrapper } = props;
    const WrapperComponent = (0, $42omo.useMemo)(()=>UNSAFE_wrapper && (0, $dh538.fg)('navx-gsn-dnc-ownership-marker') ? UNSAFE_wrapper : (0, $42omo.Fragment), [
        UNSAFE_wrapper
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ATV.AsyncIntlProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($4c2fb4ef44ce22b7$var$InnerErrorBoundary, {
                    ...props
                })
            })
        })
    });
}
function $4c2fb4ef44ce22b7$var$InnerErrorBoundary({ disableAnalytics: disableAnalytics = false, disableSentry: disableSentry = false, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, interactionId: interactionId, location: location = 'unknown', onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName }) {
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { header: header, description: description, values: values } = (0, $42omo.useMemo)(()=>(0, $kTXVr.getMessagesForLocation)(location), [
        location
    ]);
    const flags = (0, $6yeRn.useMessageFlags)({
        showFlags: showFlags
    });
    const reportError = (0, $eduVw.useUFOReportError)();
    // Use ref to store the reportError function to avoid dependency issues
    const reportErrorRef = (0, $42omo.useRef)(reportError);
    reportErrorRef.current = reportError;
    const failureTitle = formatMessage(header, values);
    const failureDescription = formatMessage(description, values);
    const onErrorUIHandler = (0, $42omo.useCallback)((error)=>{
        // Show failure flag if enabled
        flags?.showFailure?.({
            title: failureTitle,
            description: failureDescription
        });
        // Mark UFO Experience as errored if ufoInteractionName provided
        if (ufoInteractionName) reportErrorRef.current({
            name: ufoInteractionName,
            errorMessage: error.message,
            errorStack: error.stack,
            errorStatusCode: error instanceof Response ? error?.status : undefined
        });
        else {
            // Maintain backward compatibility with interactionId until removed from props
            const interactionName = interactionId && (0, $4rFRN.NavigationExperienceId)[interactionId].experienceId;
            if (interactionName) reportErrorRef.current({
                name: interactionName,
                errorMessage: error.message,
                errorStack: error.stack,
                errorStatusCode: error instanceof Response ? error?.status : undefined
            });
        }
        onError?.(error);
    }, [
        flags,
        failureDescription,
        failureTitle,
        interactionId,
        onError,
        ufoInteractionName
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        disableAnalytics: disableAnalytics,
        disableSentry: disableSentry,
        interactionId: interactionId,
        location: location,
        onError: onErrorUIHandler,
        sentryConfig: sentryConfig,
        tags: tags
    });
    // When `silent` is true or `flags` are enabled, we don't want to show any UI on error
    const errorComponent = silent || flags ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $7u5NE.ErrorBoundaryUI), {
        disableAnalytics: disableAnalytics,
        errorActionUI: errorActionUI,
        errorFallbackUI: errorFallbackUI,
        location: location
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        onError: handleError,
        fallback: errorComponent,
        children: children
    });
}
module.exports["NavErrorBoundary"] = $4c2fb4ef44ce22b7$export$afc779e659fd533f;

});

parcelRegister("kTXVr", function(module, exports) {

var $dBtY8 = parcelRequire("dBtY8");


var $lf8Yh = parcelRequire("lf8Yh");

function $03436e25535634a1$export$3331c7144beb2006(location) {
    const [baseLocation, uuId] = location?.split('--') || [];
    switch(baseLocation){
        case 0, $dBtY8.ERROR_LOCATION__CUSTOMIZATION_MODAL:
            return 0, $lf8Yh.customizationMessages;
        case 0, $dBtY8.ERROR_LOCATION__DRAG_AND_DROP:
            return 0, $lf8Yh.dndMessages;
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_MORE_MENU:
            return 0, $lf8Yh.moreMenuMessages;
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_MORE_MENU_ITEM:
            return {
                ...(0, $lf8Yh.moreMenuItemMessages),
                values: {
                    uuId: uuId
                }
            };
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS:
            return {
                ...(0, $lf8Yh.shortcutsMessages),
                values: {
                    uuId: uuId
                }
            };
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION:
            return 0, $lf8Yh.sideNavMessages;
        case 0, $dBtY8.ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS:
            return 0, $lf8Yh.sideNavItemActionsMenuMessages;
        case 0, $dBtY8.ERROR_LOCATION__GSN_MAIN_NAV_ITEM:
            return {
                ...(0, $lf8Yh.sideNavMainItemMessages),
                values: {
                    uuId: uuId
                }
            };
        default:
            return 0, $lf8Yh.defaultMessages;
    }
}
module.exports["getMessagesForLocation"] = $03436e25535634a1$export$3331c7144beb2006;

});

parcelRegister("lf8Yh", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $797668988538d21a$export$628f6f7219a6b8b6 = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.default",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.error.description.default",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$8587940f17f4d26 = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.customization-modal",
        defaultMessage: "We couldn\u2019t load your customization options"
    },
    description: {
        id: "navigation.error.description.customization-modal",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$9cce36fc218ef04c = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.global-more-menu",
        defaultMessage: "We couldn\u2019t load more options"
    },
    description: {
        id: "navigation.error.description.global-more-menu",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$9483ff6124cf0a32 = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.global-side-navigation",
        defaultMessage: "We couldn\u2019t load the sidebar"
    },
    description: {
        id: "navigation.error.description.global-side-navigation",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$18eaee65a8fa9237 = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.global-side-navigation-nav-item-actions",
        defaultMessage: "We couldn\u2019t load more actions"
    },
    description: {
        id: "navigation.error.description.global-side-navigation-nav-item-actions",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$a8585c3005ff8118 = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.ui.header.drag-and-drop",
        defaultMessage: "We couldn\u2019t complete this action"
    },
    description: {
        id: "navigation.error.ui.description.drag-and-drop",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$60436671aeff828f = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.global-shortcuts",
        defaultMessage: "We couldn\u2019t load the app {uuId}"
    },
    description: {
        id: "navigation.error.description.global-shortcuts",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$4e37cb57ad07debd = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.gsn-main-nav-item",
        defaultMessage: "We couldn\u2019t load the item {uuId}"
    },
    description: {
        id: "navigation.error.description.gsn-main-nav-item",
        defaultMessage: "Refresh the page and try again"
    }
});
const $797668988538d21a$export$f42365f921d34fe8 = (0, $h82at.defineMessages)({
    header: {
        id: "navigation.error.header.global-more-menu-item",
        defaultMessage: "We couldn\u2019t load {uuId} in more options"
    },
    description: {
        id: "navigation.error.description.global-more-menu-item",
        defaultMessage: "Refresh the page and try again"
    }
});
module.exports["defaultMessages"] = $797668988538d21a$export$628f6f7219a6b8b6;
module.exports["customizationMessages"] = $797668988538d21a$export$8587940f17f4d26;
module.exports["moreMenuMessages"] = $797668988538d21a$export$9cce36fc218ef04c;
module.exports["sideNavMessages"] = $797668988538d21a$export$9483ff6124cf0a32;
module.exports["sideNavItemActionsMenuMessages"] = $797668988538d21a$export$18eaee65a8fa9237;
module.exports["dndMessages"] = $797668988538d21a$export$a8585c3005ff8118;
module.exports["shortcutsMessages"] = $797668988538d21a$export$60436671aeff828f;
module.exports["sideNavMainItemMessages"] = $797668988538d21a$export$4e37cb57ad07debd;
module.exports["moreMenuItemMessages"] = $797668988538d21a$export$f42365f921d34fe8;

});

parcelRegister("a9ATV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $eB7BJ = parcelRequire("eB7BJ");


var $3BKI5 = parcelRequire("3BKI5");

function $c5e5f2aa3b0d680d$export$2f688dfcc031530a({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $eB7BJ.default),
        loaderFn: $c5e5f2aa3b0d680d$var$fetchMessagesForLocale,
        children: children
    });
}
async function $c5e5f2aa3b0d680d$var$fetchMessagesForLocale(locale) {
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $3BKI5.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $3BKI5.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $eB7BJ.default);
    } catch  {
    // ignore
    }
    return 0, $eB7BJ.default;
}
module.exports["AsyncIntlProvider"] = $c5e5f2aa3b0d680d$export$2f688dfcc031530a;

});

parcelRegister("eB7BJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d4d83780c7949fa7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bK0Vj = parcelRequire("bK0Vj");

var $d4d83780c7949fa7$export$2e2bcd8739ae039 = (0, $bK0Vj.default);

});

parcelRegister("bK0Vj", function(module, exports) {
$parcel$export(module.exports, "default", () => $40c8554630cee504$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $40c8554630cee504$export$2e2bcd8739ae039 = {
    'navigation.error.description.customization-modal': 'Refresh the page and try again',
    'navigation.error.description.default': 'Refresh the page and try again',
    'navigation.error.description.global-more-menu': 'Refresh the page and try again',
    'navigation.error.description.global-more-menu-item': 'Refresh the page and try again',
    'navigation.error.description.global-shortcuts': 'Refresh the page and try again',
    'navigation.error.description.global-side-navigation': 'Refresh the page and try again',
    'navigation.error.description.global-side-navigation-nav-item-actions': 'Refresh the page and try again',
    'navigation.error.description.gsn-main-nav-item': 'Refresh the page and try again',
    'navigation.error.header.customization-modal': "We couldn\u2019t load your customization options",
    'navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.error.header.global-more-menu': "We couldn\u2019t load more options",
    'navigation.error.header.global-more-menu-item': "We couldn\u2019t load {uuId} in more options",
    'navigation.error.header.global-shortcuts': "We couldn\u2019t load the app {uuId}",
    'navigation.error.header.global-side-navigation': "We couldn\u2019t load the sidebar",
    'navigation.error.header.global-side-navigation-nav-item-actions': "We couldn\u2019t load more actions",
    'navigation.error.header.gsn-main-nav-item': "We couldn\u2019t load the item {uuId}",
    'navigation.error.ui.description.drag-and-drop': 'Refresh the page and try again',
    'navigation.error.ui.header.drag-and-drop': "We couldn\u2019t complete this action"
};

});

parcelRegister("3BKI5", function(module, exports) {
// https://parceljs.org/features/dependency-resolution/#glob-specifiers




























const $c667adb400559b66$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("4AVTD")),
    da: ()=>(parcelRequire("k4Ine")),
    de: ()=>(parcelRequire("7YRaF")),
    'en-GB': ()=>(parcelRequire("iVnJf")),
    'en-ZZ': ()=>(parcelRequire("kmblI")),
    en: ()=>Promise.resolve((parcelRequire("eB7BJ"))),
    es: ()=>(parcelRequire("jPeNE")),
    fi: ()=>(parcelRequire("gzopq")),
    fr: ()=>(parcelRequire("aL5By")),
    hr: ()=>(parcelRequire("9qoF1")),
    hu: ()=>(parcelRequire("gqVWX")),
    it: ()=>(parcelRequire("jSq5F")),
    ja: ()=>(parcelRequire("j29KS")),
    ko: ()=>(parcelRequire("bwCVT")),
    nb: ()=>(parcelRequire("gTSL0")),
    // nl: () =>
    // 	import(
    // 		/* webpackChunkName: "@atlaskit-internal_@atlassian/navigation-error-boundary-i18n-nl" */ '../../../i18n/nl'
    // 	),
    pl: ()=>(parcelRequire("9qC4p")),
    'pt-BR': ()=>(parcelRequire("5oI7Y")),
    ru: ()=>(parcelRequire("hFpC3")),
    sl: ()=>(parcelRequire("gOPix")),
    'sr-RS': ()=>(parcelRequire("8BBUz")),
    'sr-YR': ()=>(parcelRequire("Qg6FR")),
    sv: ()=>(parcelRequire("9ehaJ")),
    th: ()=>(parcelRequire("kJgzR")),
    tr: ()=>(parcelRequire("1m6Vi")),
    uk: ()=>(parcelRequire("8X2Nj")),
    vi: ()=>(parcelRequire("64h8l")),
    zh_TW: ()=>(parcelRequire("gkyBQ")),
    zh: ()=>(parcelRequire("3BiPW"))
};
module.exports["asyncLanguages"] = $c667adb400559b66$export$3770c7a7737d463c;

});

parcelRegister("4AVTD", function(module, exports) {

let $35876f3524946fc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35876f3524946fc1$var$load("d4ByE").then(()=>parcelRequire('a4nWN'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("k4Ine", function(module, exports) {

let $e9d69a15e3f94393$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9d69a15e3f94393$var$load("5hSoy").then(()=>parcelRequire('3Fkcb'));

});

parcelRegister("7YRaF", function(module, exports) {

let $5cf761aca73998e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cf761aca73998e6$var$load("7VsjH").then(()=>parcelRequire('uLMk8'));

});

parcelRegister("iVnJf", function(module, exports) {

let $dc6ff4ed35144d3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc6ff4ed35144d3c$var$load("a268B").then(()=>parcelRequire('9bFeu'));

});

parcelRegister("kmblI", function(module, exports) {

let $ed1eaa6cdadcf8e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed1eaa6cdadcf8e6$var$load("lhSi1").then(()=>parcelRequire('kJOzS'));

});

parcelRegister("jPeNE", function(module, exports) {

let $e6ee42ac2282811f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6ee42ac2282811f$var$load("ft9Ll").then(()=>parcelRequire('dv9cK'));

});

parcelRegister("gzopq", function(module, exports) {

let $c102d958a33629d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c102d958a33629d1$var$load("jTa87").then(()=>parcelRequire('guy58'));

});

parcelRegister("aL5By", function(module, exports) {

let $7d52a42594142cfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d52a42594142cfc$var$load("aNiGa").then(()=>parcelRequire('ksVsc'));

});

parcelRegister("9qoF1", function(module, exports) {

let $6dc9abde5dd1422f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dc9abde5dd1422f$var$load("4r8Lc").then(()=>parcelRequire('5Ce6L'));

});

parcelRegister("gqVWX", function(module, exports) {

let $bf6c06af68a1f87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf6c06af68a1f87f$var$load("hgY73").then(()=>parcelRequire('kb6NW'));

});

parcelRegister("jSq5F", function(module, exports) {

let $e7874c794a3d4bb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7874c794a3d4bb3$var$load("dlCkw").then(()=>parcelRequire('eO4ch'));

});

parcelRegister("j29KS", function(module, exports) {

let $ddb5c55edcd44f28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddb5c55edcd44f28$var$load("l9GjK").then(()=>parcelRequire('fwmUv'));

});

parcelRegister("bwCVT", function(module, exports) {

let $8640e2173d4bc27d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8640e2173d4bc27d$var$load("fz30M").then(()=>parcelRequire('jU4cW'));

});

parcelRegister("gTSL0", function(module, exports) {

let $c4dc4202454ae5d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4dc4202454ae5d6$var$load("kALI0").then(()=>parcelRequire('hClVv'));

});

parcelRegister("9qC4p", function(module, exports) {

let $6dd412aba2dfa617$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dd412aba2dfa617$var$load("JRBbC").then(()=>parcelRequire('jYcr9'));

});

parcelRegister("5oI7Y", function(module, exports) {

let $3ee16c760a830f7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ee16c760a830f7c$var$load("9eERo").then(()=>parcelRequire('57dQu'));

});

parcelRegister("hFpC3", function(module, exports) {

let $cdca2226e651accf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cdca2226e651accf$var$load("9kBhC").then(()=>parcelRequire('blWCR'));

});

parcelRegister("gOPix", function(module, exports) {

let $c3e91b8f399b2bcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3e91b8f399b2bcd$var$load("bzIZv").then(()=>parcelRequire('15Tpv'));

});

parcelRegister("8BBUz", function(module, exports) {

let $643f2fd6bd274a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $643f2fd6bd274a01$var$load("ab9gs").then(()=>parcelRequire('g2vDV'));

});

parcelRegister("Qg6FR", function(module, exports) {

let $09d159e3668e805c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09d159e3668e805c$var$load("awEHL").then(()=>parcelRequire('9jpbR'));

});

parcelRegister("9ehaJ", function(module, exports) {

let $6b82bde1e08509aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b82bde1e08509aa$var$load("d0TBI").then(()=>parcelRequire('dxZc6'));

});

parcelRegister("kJgzR", function(module, exports) {

let $f174de86bfa0e7f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f174de86bfa0e7f0$var$load("44Tsr").then(()=>parcelRequire('aYhka'));

});

parcelRegister("1m6Vi", function(module, exports) {

let $0fcd3753fb562f68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fcd3753fb562f68$var$load("52Fkw").then(()=>parcelRequire('7Xh53'));

});

parcelRegister("8X2Nj", function(module, exports) {

let $6846005456532c80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6846005456532c80$var$load("15Ksq").then(()=>parcelRequire('iniEE'));

});

parcelRegister("64h8l", function(module, exports) {

let $46b068291a809bb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46b068291a809bb5$var$load("7uvuw").then(()=>parcelRequire('5jale'));

});

parcelRegister("gkyBQ", function(module, exports) {

let $be395c4d4375c70e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be395c4d4375c70e$var$load("8j70M").then(()=>parcelRequire('jf30t'));

});

parcelRegister("3BiPW", function(module, exports) {

let $29f3706877351e56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29f3706877351e56$var$load("7d6QX").then(()=>parcelRequire('eRE7P'));

});

parcelRegister("6yeRn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");


var $7yDmn = parcelRequire("7yDmn");

function $a32d3e2214df8275$export$ad59d437e6db3634({ showFlags: showFlags = false }) {
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const flags = (0, $42omo.useMemo)(()=>({
            showFailure: ({ title: title, description: description, actions: actions })=>{
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $a32d3e2214df8275$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $a32d3e2214df8275$var$flagsIds.failure,
                    title: title
                });
            }
        }), [
        showFlag
    ]);
    return !showFlags ? undefined : flags;
}
const $a32d3e2214df8275$var$flagsIds = {
    failure: 'nav-error-boundary-failure-flag'
};
module.exports["useMessageFlags"] = $a32d3e2214df8275$export$ad59d437e6db3634;

});

parcelRegister("7u5NE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $d1p2I = parcelRequire("d1p2I");


var $4NsV7 = parcelRequire("4NsV7");


var $kTXVr = parcelRequire("kTXVr");

function $08962ae18cab1bac$export$ed65a7143a39e5b6({ disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location }) {
    const intl = (0, $1cfRh.default)();
    const { fireEvent: fireEvent } = (0, $4NsV7.useAnalyticsEvents)();
    const { header: header, description: description, values: values } = (0, $kTXVr.getMessagesForLocation)(location);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!disableAnalytics) fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
            location: location,
            isFallbackUI: !!errorFallbackUI
        });
    }, [
        disableAnalytics,
        errorFallbackUI,
        fireEvent,
        location
    ]);
    // If a custom fallback UI is provided, render it directly at risk of consumer
    if (errorFallbackUI) return errorFallbackUI({
        header: intl.formatMessage(header, values),
        description: intl.formatMessage(description, values)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d1p2I.NavEmptyState), {
        testId: "navigation-error-boundary-ui",
        header: intl.formatMessage(header, values),
        description: intl.formatMessage(description, values),
        primaryAction: errorActionUI
    });
}
module.exports["ErrorBoundaryUI"] = $08962ae18cab1bac$export$ed65a7143a39e5b6;

});


//# sourceMappingURL=GlobalAppShortcutsSection.70cd4a36.js.map
